import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0ff44f5f")

_pushScopeId("data-v-0ff44f5f")
const _hoisted_1 = { class: "p-fluid p-formgrid p-grid p-mx-2 p-my-4" }
const _hoisted_2 = { class: "p-field p-col-12" }
const _hoisted_3 = { class: "kn-material-input-label" }
const _hoisted_4 = { class: "p-field p-col-12" }
const _hoisted_5 = { class: "kn-material-input-label" }
const _hoisted_6 = { class: "p-d-flex p-flex-row p-jc-end p-col-12" }
const _hoisted_7 = { class: "max-length-help p-m-0" }
const _hoisted_8 = { class: "p-field p-col-12" }
const _hoisted_9 = { class: "kn-material-input-label" }
const _hoisted_10 = { class: "p-d-flex p-flex-row p-jc-end p-col-12" }
const _hoisted_11 = { class: "max-length-help p-m-0" }
const _hoisted_12 = { class: "p-field p-col-12" }
const _hoisted_13 = { class: "kn-material-input-label" }
const _hoisted_14 = { class: "p-grid p-mt-4" }
const _hoisted_15 = { class: "p-field p-col-6" }
const _hoisted_16 = { class: "kn-material-input-label" }
const _hoisted_17 = { class: "p-field p-col-6" }
const _hoisted_18 = { class: "kn-material-input-label" }
const _hoisted_19 = { class: "p-field p-col-12" }
const _hoisted_20 = { class: "kn-material-input-label" }
const _hoisted_21 = { id: "reply-to-help" }
const _hoisted_22 = { class: "p-d-flex p-flex-row p-jc-end" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Editor = _resolveComponent("Editor")
  const _component_Message = _resolveComponent("Message")
  const _component_AccordionTab = _resolveComponent("AccordionTab")
  const _component_Accordion = _resolveComponent("Accordion")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "p-fluid kn-dialog--toolbar--primary",
    contentStyle: _ctx.documentExecutionMailDialogDescriptor.dialog.style,
    visible: _ctx.visible,
    modal: true,
    closable: false
  }, {
    header: _withId(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-p-0 p-m-0 p-col-12" }, {
        start: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.sendMail')), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withId(() => [
      _createVNode("div", _hoisted_22, [
        _createVNode(_component_Button, {
          class: "kn-button kn-button--primary",
          onClick: _ctx.closeDialog
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_Button, {
          class: "kn-button kn-button--primary",
          onClick: _ctx.save,
          disabled: _ctx.saveButtonDisabled
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
          ]),
          _: 1
        }, 8, ["onClick", "disabled"])
      ])
    ]),
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('common.to')) + " *", 1),
          _createVNode(_component_InputText, {
            class: ["kn-material-input p-inputtext-sm", {
                        'p-invalid': _ctx.mailToDirty && (!_ctx.mail.TO || _ctx.mail.TO.length === 0)
                    }],
            modelValue: _ctx.mail.TO,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.mail.TO = $event)),
            onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.mailToDirty = true)),
            onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.mailToDirty = true))
          }, null, 8, ["modelValue", "class"])
        ]),
        _createVNode("div", _hoisted_4, [
          _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('common.cc')), 1),
          _createVNode(_component_InputText, {
            class: "kn-material-input p-inputtext-sm",
            modelValue: _ctx.mail.CC,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.mail.CC = $event)),
            maxLength: _ctx.documentExecutionMailDialogDescriptor.ccMaxLength
          }, null, 8, ["modelValue", "maxLength"])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("p", _hoisted_7, _toDisplayString(_ctx.ccHelp), 1)
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("label", _hoisted_9, _toDisplayString(_ctx.$t('common.object')), 1),
          _createVNode(_component_InputText, {
            class: "kn-material-input p-inputtext-sm",
            modelValue: _ctx.mail.OBJECT,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.mail.OBJECT = $event)),
            maxLength: _ctx.documentExecutionMailDialogDescriptor.objectMaxLength
          }, null, 8, ["modelValue", "maxLength"])
        ]),
        _createVNode("div", _hoisted_10, [
          _createVNode("p", _hoisted_11, _toDisplayString(_ctx.objectHelp), 1)
        ]),
        _createVNode("div", _hoisted_12, [
          _createVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('common.message')), 1),
          _createVNode(_component_Editor, {
            modelValue: _ctx.mail.MESSAGE,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.mail.MESSAGE = $event)),
            class: "p-m-2",
            editorStyle: _ctx.documentExecutionMailDialogDescriptor.editor.style
          }, null, 8, ["modelValue", "editorStyle"])
        ]),
        _createVNode(_component_Accordion, { class: "p-col-12" }, {
          default: _withId(() => [
            _createVNode(_component_AccordionTab, null, {
              header: _withId(() => [
                _createVNode("span", null, _toDisplayString(_ctx.$t('common.advanced')), 1)
              ]),
              default: _withId(() => [
                _createVNode(_component_Message, {
                  class: "p-m-2",
                  severity: "info",
                  closable: false,
                  style: _ctx.documentExecutionMailDialogDescriptor.styles.message
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('documentExecution.main.sendEmailMessage')), 1)
                  ]),
                  _: 1
                }, 8, ["style"]),
                _createVNode("div", _hoisted_14, [
                  _createVNode("div", _hoisted_15, [
                    _createVNode("label", _hoisted_16, _toDisplayString(_ctx.$t('common.login')), 1),
                    _createVNode(_component_InputText, {
                      class: "kn-material-input p-inputtext-sm",
                      modelValue: _ctx.mail.LOGIN,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.mail.LOGIN = $event)),
                      maxLength: _ctx.documentExecutionMailDialogDescriptor.objectMaxLength
                    }, null, 8, ["modelValue", "maxLength"])
                  ]),
                  _createVNode("div", _hoisted_17, [
                    _createVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('common.password')), 1),
                    _createVNode(_component_InputText, {
                      class: "kn-material-input p-inputtext-sm",
                      type: "password",
                      modelValue: _ctx.mail.PASSWORD,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.mail.PASSWORD = $event)),
                      maxLength: _ctx.documentExecutionMailDialogDescriptor.objectMaxLength
                    }, null, 8, ["modelValue", "maxLength"])
                  ]),
                  _createVNode("div", _hoisted_19, [
                    _createVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('common.replyTo')), 1),
                    _createVNode(_component_InputText, {
                      class: "kn-material-input p-inputtext-sm",
                      modelValue: _ctx.mail.REPLAYTO,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.mail.REPLAYTO = $event)),
                      maxLength: _ctx.documentExecutionMailDialogDescriptor.objectMaxLength,
                      "aria-describedby": "reply-to-help"
                    }, null, 8, ["modelValue", "maxLength"]),
                    _createVNode("small", _hoisted_21, _toDisplayString(_ctx.$t('documentExecution.main.replyToHint')), 1)
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["contentStyle", "visible"]))
})